import { boolValOrUndef, strVal, strValOrUndef } from "@paroi/data-formatters-lib";

export interface Organization {
  id: string;
  logo?: string;
  name?: string;
  acronym?: string;
  enabled: boolean;
  description?: string;
  ownerName?: string;
  ownerEmail?: string;
  createdAt?: string;
  phone?: string;
  address?: string;
}

export function formatToOrganization(data: any): Organization {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid organization data");
  }
  return {
    id: strVal(data.id),
    name: strValOrUndef(data.name),
    acronym: strValOrUndef(data.acronym),
    description: strValOrUndef(data.description),
    enabled: boolValOrUndef(data.enabled) ?? false,
    logo: strValOrUndef(data.logo),
    ownerName: strValOrUndef(data.owner_name),
    ownerEmail: strValOrUndef(data.owner_email),
    phone: strValOrUndef(data.phone),
    address: strValOrUndef(data.address),
    createdAt: strValOrUndef(data.created_at),
  };
}
